const MODEL_NAME = 'common'
export default [
  {
    path: `/${MODEL_NAME}/open-app`,
    name: 'openApp',
    component: () =>
      import(/* webpackChunkName: "common-open-app" */ '@pages/common/open-app/index.vue')
  }
]
